import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "select", "nameField", "slugField"]

  show() {
    this.contentTarget.classList.toggle("hidden")
  }

  update() {
    const option = this.selectTarget.selectedOptions[0]
    this.nameFieldTarget.value = option.text
    this.slugFieldTarget.value = option.dataset.slug
  }
}
